import api from './axios';

/* ── The 25-chapter course, with the learner's progress folded in ──
   GET /api/grammar/chapters
   🔒 Requires user token
─────────────────────────────────────────────────────────────── */
export const getGrammarChapters = async (level = 'N5') => {
  const { data } = await api.get('/grammar/chapters', { params: { level } });
  return data;
};

/* ── One chapter: intro, key points, and every part with sentences ──
   GET /api/grammar/chapters/:number
   🔒 Requires user token
─────────────────────────────────────────────────────────────── */
export const getGrammarChapter = async (number, level = 'N5') => {
  const { data } = await api.get(`/grammar/chapters/${number}`, { params: { level } });
  return data;
};

/* ── Bank a finished part ────────────────────────────────────────
   POST /api/grammar/parts/complete
   The server owns the pass mark; we only report what was scored.
   🔒 Requires user token
─────────────────────────────────────────────────────────────── */
export const completeGrammarPart = async ({ chapter, part, scorePct, level = 'N5' }) => {
  const { data } = await api.post('/grammar/parts/complete', { chapter, part, scorePct, level });
  return data;
};

/* ══════════════════════════════════════════════════════════════
   ADMIN
══════════════════════════════════════════════════════════════ */

export const adminGetGrammarChapters = async () => {
  const { data } = await api.get('/admin/grammar-chapters');
  return data;
};

export const adminGetGrammarChapter = async (id) => {
  const { data } = await api.get(`/admin/grammar-chapters/${id}`);
  return data;
};

export const adminCreateGrammarChapter = async (body) => {
  const { data } = await api.post('/admin/grammar-chapters', body);
  return data;
};

export const adminUpdateGrammarChapter = async (id, body) => {
  const { data } = await api.put(`/admin/grammar-chapters/${id}`, body);
  return data;
};

export const adminDeleteGrammarChapter = async (id) => {
  const { data } = await api.delete(`/admin/grammar-chapters/${id}`);
  return data;
};
